import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class VatRate {

  @JsonProperty()
  id: number = -1;
  @JsonProperty()
  country: string | undefined;
  @JsonProperty()
  code: string | undefined;
  @JsonProperty()
  rate: number;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();
  @JsonProperty()
  creationDate: DateTime;

}
